<template>
  <div id="app">
    <div
      v-if="this.$route.name !== 'Manutencao' && this.$route.name !== 'Compre'"
    >
      <div id="navegador" v-if="!proprias.includes(this.$route.name)">
        <Navbar />
        <!-- <div id="nav"> -->
          <!-- <div id="logo">
            <router-link :to="`/`" id="logomarcaLink">
              <img src="./assets/logo.png" alt="Empório das Marcas" />
            </router-link>
          </div> -->

          <!-- <div id="opcoes">
            <input type="checkbox" id="bt_menu">
            <label for="bt_menu">&#9776;</label> -->
          <!-- <div id="busca">
              <div id="barra_search">
                <input
                  v-model="search"
                  v-on:keyup.enter="searchProduct()"
                  placeholder="Procupe por código, marca, nome..."
                />
                <div id="material_icon_search">
                  <i class="material-icons" id="search_icon" v-on:click="searchProduct()">search</i>
                </div>
              </div>
            </div> -->
          <!-- <div id="routes">
            <div v-for="item in categorias" :key="item._id" id="topnav"> -->
              <!-- <router-link @mouseout="getSubCategorias(item._id)" :to="`/${item.nome.toLowerCase()}`" id="categoria">{{ -->
              <!-- <button
                type="button"
                @mouseover="getSubCategorias(item._id)"
                id="categoria"
              >
                {{ item.nome }}
              </button> -->
              <!-- }}</router-link> -->
            <!-- </div>
          </div> -->
          <!-- </div> -->
          <!-- <div id="options">
            <p id="sign_in" v-if="nome !== ''">
              <router-link :to="`/login`">Olá, {{ nome }}!</router-link>
            </p>
            <p id="sign_in" v-else>
              <router-link :to="`/login`">Entrar/Cadastrar</router-link>
            </p>
            <span class="material-icons" id="show-menu-btn">more_horiz</span>

            <router-link :to="`/sacola`">
              <i class="material-icons" id="sacola_icon">local_mall</i>
            </router-link>
          </div>
        </div> -->
        <!-- <div id="submenu2">
          <div
            v-for="subTable in subcategorias"
            :key="subTable[0]._id"
            id="subCategoriasRow"
          >
            <div
              v-for="item in subTable"
              :key="item._id"
              id="subCategoriasItems"
            >
              <router-link
                v-if="item.nome"
                :to="`/${encodeURIComponent(item.cat_nome.toLowerCase())}?sub=${encodeURIComponent(item.nome.toLowerCase())}`"
                id="subcategoria"
                @click="this.subcategorias = []"
                >{{ item.nome }}</router-link
              >
            </div>
          </div>
        </div> -->
      </div>
      <router-view />

      <Footerr :categorias="categorias"  v-if="!proprias.includes(this.$route.name)" />
    </div>
    <div v-else-if="this.$route.name === 'Compre'">
      <router-view />
    </div>
    <div v-else>
      <div id="manutencao">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Footerr from "./components/Footerr";
import axios from "axios";
import proprias from "./store/telasproprias";
import Navbar from './components/NavBar';
export default {
  components: {
    Footerr,
    Navbar
  },
  watch: {
    $route() {
      this.getInfo();
      if (this.$route.name === "Login") {
        this.showNav = false;
      }
      this.search = "";
    },
  },
  data() {
    return {
      categorias: [],
      proprias: proprias,
      subcategorias: [],
      search: "",
      nome: "",
      showNav: true,
    };
  },
  async beforeMount() {
    await this.sendInfo();
    this.getInfo();
    this.getCategorias();
  },
  methods: {
    async sendInfo() {
      try {
        let dados = JSON.parse(localStorage.getItem("uiid"));
        if (!dados) {
          let info = await axios.get("http://ip-api.com/json?callback=?");

          if (info) {
            let infor = JSON.parse(info.data.slice(2, -2));

            let user = JSON.parse(localStorage.getItem("usuario"));

            let user_ = null;

            if (user && user.user && user.user._id) {
              user_ = user.user._id;
            }

            await this.$http
              .post("/opens/control/add", {
                address: infor.query,
                country: infor.country,
                region: infor.region,
                city: infor.city,
                place: "WC",
                user: user_,
              })
              .then((res) => {
                localStorage.setItem("uiid", res.data._id);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          let info = await axios.get("http://ip-api.com/json?callback=?");

          if (info) {
            let infor = JSON.parse(info.data.slice(2, -2));

            let user = JSON.parse(localStorage.getItem("usuario"));

            let user_ = null;

            if (user && user.user && user.user._id) {
              user_ = user.user._id;
            }

            await this.$http
              .post(`/opens/control/${dados}`, {
                address: infor.query,
                country: infor.country,
                region: infor.region,
                city: infor.city,
                place: infor.place,
                user: user_,
              })
              .then((res) => {
                localStorage.setItem("uiid", res.data._id);
              })
              .catch(() => {});
          }
        }
      } catch (err) {
        console.log("Well...");
      }
    },
    getInfo() {
      this.nome = "";
      let user = JSON.parse(localStorage.getItem("usuario"));
      if (user) {
        this.$http
          .get(`/projects/cliente/${user.cliente._id}`)
          .then((res) => {
            this.nome = res.data.cliente.nome;
          })
          .catch(() => {
            this.nome = "";
            localStorage.setItem("usuario", null);
          });
      }
    },
    searchProduct() {
      this.$router.push(`/search?q=${encodeURIComponent(this.search)}`);
    },
    getCategorias() {
      this.$http
        .get("/opens/categorias")
        .then((res) => {
          this.categorias = res.data.categorias;
        })
        .catch(() => {
          this.$router.push("/manutencao");
        });
    },
    getSubCategorias(id) {
      this.$http
        .get(`/opens/subcategorias`)
        .then((res) => {
          let todas = res.data.subcategorias;
  
          let unicas = [[], [], [], []];

          let coluna = 0;

          for (let e of todas) {
            let cat_ = this.categorias;
            let c_ = "";
            for(let i of cat_){
              if(i._id == id){
                c_ = i.nome;
              }
            }
            if (e && e.categoria && e.categoria === id) {
              e.cat_nome = c_;
              unicas[coluna].push(e);
              switch (coluna) {
                case 0:
                  coluna = 1;
                  break;
                case 1:
                  coluna = 2;
                  break;
                case 2:
                  coluna = 3;
                  break;
                case 3:
                  coluna = 0;
                  break;
                default:
                  coluna = 0;
                  break;
              }
            }
          }

          let t_altura = unicas[0].length;

          let t_larg = unicas.length;


          for (let i = 0; i < t_altura; i++) {
            for (let j = 0; j < t_larg; j++) {
              if (!unicas[j][i]) {
                unicas[j][i] = "";
              }
            }
          }

          this.subcategorias = unicas;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>


<style>
* {
  margin: 0 auto;
  padding: 0;
  width: 100%;
}

label[for="bt_menu"] {
  padding: 5px;
  background-color: #222;
  color: #000000;
  font-family: "Arial";
  text-align: center;
  font-size: 30px;
  cursor: pointer;
  width: 50px;
  height: 50px;
}

button:focus {
  outline: none;
}

#manutencao {
  background-color: #8d816b;
  height: 100%;
  width: 100%;
}

#show-menu-btn {
  visibility: hidden;
  color: #332f28;
  float: right;
}

#show-menu-btn:hover {
  color: #8d816b;
}

#show-menu-btn,
.hide-menu-btn {
  transition: 0.4s;
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#search_icon {
  cursor: pointer;
  align-content: flex-end;
  width: 50px;
  color: #e3d2ad;
  display: block;
  margin-top: 10px;
  padding: 2px;
}

#navegador {
  /* background-color: #e3d2ad; */
  /* align-items: center; */
  /* display: flex; */
  /* flex-direction: row; */
  /* flex-wrap: wrap;
  flex-flow: row wrap;
  justify-content: space-between; */
  /* margin: 0 auto; */
}

#logo {
  align-items: center;
  width: auto;
  height: auto;
  margin: 5px;
}

#material_icon_search {
  width: 50px;
  display: block;
  align-items: center;
}

#material_icon_search i {
  display: table-cell;
  justify-content: center;
}

#logo img {
  height: 100px;
  width: auto;
  float: left;
  padding-bottom: 10px;
}

#options {
  width: 20%;
  align-items: center;
  justify-items: center;
  display: inline-flex;
}

.router-link-active {
  text-decoration: none;
  font-style: inherit;
  font-weight: none;
  border-width: none;
}

li a {
  text-decoration: none;
}

#barra_search input {
  border: none;
  display: block;
  height: 33px;
  width: 98%;
  padding: 13px;
  border-radius: 10px;
}

#busca {
  background-color: #ffffff;
  border-radius: 10px;
}

#nav {
  padding: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  justify-content: space-between;
  /* justify-content: center; */
  /* overflow: hidden; */
  /* display: inline-flex; */
}

#routes {
  /* display: inline-block; */
  text-transform: uppercase;
  margin-top: 20px;
  width: auto;
}

#sacola_icon {
  color: #000000;
  display: inline-block;
  width: 50px;
  margin-left: 20px;
  text-align: center;
}

#opcoes {
  flex: left;
  width: auto;
  align-self: flex-end;
}

#nav a {
  font-weight: bold;
  color: #000;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
}

#barra_search {
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 5px;
}

#sign_in {
  /* text-align: center; */
  /* display: inline-flex; */
  /* width: 160px; */
  margin-left: 20px;
  cursor: pointer;
  font-size: 12px;
}

#routes a:hover {
  /* background-color: #8d816b; */
  padding: 10px;
  /* font-size: 13px; */
  font-weight: bold;
  border-bottom: 1px solid #8d816b;
  /* color: #ffffff; */
}

#nav a.router-link-exact-active {
  /* color: #ffffff; */
  font-weight: bold;
  border-bottom: 1px solid #8d816b;
}

input:focus {
  outline: none;
}

#topnav {
  float: left;
  width: auto;
  color: #000;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
  display: inline-table;
}

#submenu2 {
  position: relative;
  background-color: #e3e3e3;
  color: #000;
  font-weight: 500;
}

#submenu2 {
}

#categoria {
  font-size: 14px;
}

#subcategoria {
  font-size: 14px;
}

#subCategoriasRow {
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  justify-items: flex-start;
  align-content: stretch;
  /* width: 70%; */
}

#logomarcaLink {
  text-decoration: none;
}

#subCategoriasItems {
  text-align: left;
}

@media screen and (max-width: 800px) {
  #app {
    width: 100%;
  }

  #nav {
    display: grid;
    justify-items: center;
  }

  #logo {
    padding: 0;
  }

  #logo img {
    height: 90px;
    width: 90px;
    object-fit: cover;
  }

  #options {
    width: auto;
  }

  #routes {
    display: grid;
    text-align: center;
  }

  #carousel {
    height: 70px;
  }

  #busca {
    margin-bottom: 10px;
  }

  #topnav {
    float: left;
    width: auto;
    color: #f2f2f2;
    text-align: center;
    padding: 1px 0px;
    text-decoration: none;
    font-size: 17px;
    display: inline-table;
  }

  #categoria {
    display: block;
    text-align: center;
    width: auto;
  }
}
</style>
